import _ from "lodash";
import ResultBook from "./ResultBook";
import { useBookStore } from "stores/bookStore";
import { useAppStore } from "stores/appStore";
import { DOCUMENT_CATEGORY_KE_HOACH_BAI_DAY_2 } from "consts/book";

export default function SectionKeHoachBaiDay2() {
  const documents = useBookStore((state) => state.documents);
  const subjectId = useAppStore((state) => state.subjectId);
  const gradeId = useAppStore((state) => state.gradeId);
  const documentsOfCurrentGrade = _.get(documents, [gradeId], []);

  const tlbtDocuments = documentsOfCurrentGrade.filter(
    (item) =>
      item.category === DOCUMENT_CATEGORY_KE_HOACH_BAI_DAY_2 &&
      item.subject_id === subjectId
  );

  return (
    !_.isEmpty(tlbtDocuments) && (
      <div className="col-md-12 result">
        <ResultBook
          data={tlbtDocuments}
          bookTypeId={DOCUMENT_CATEGORY_KE_HOACH_BAI_DAY_2}
          categoryBook="Kế hoạch bài dạy"
          col={gradeId == 27 ? "col-6 col-lg-2" : "col-6 col-lg-3"}
          background="#fff"
        />
      </div>
    )
  );
}
